import React from 'react';
import styled from 'styled-components';
import * as Icon from '@ant-design/icons';

const Wrapper = styled.div`
  position: fixed;
  right: 10px;
  top: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

const Button = styled.a`
  width: 40px;
  height: 40px;
  font-size: 20px;
  border-radius: 20px;
  background: white;
  border: 2px solid #134E8F;
  display: flex;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  color: #134E8F;
  transition: all 0.3s;
  :hover {
    background: #134E8F;
    color: white;
  }
  ::after {
    display: none;
  }
`;

const Icons = {
  facebook: Icon.FacebookOutlined,
  linkedin: Icon.LinkedinOutlined,
  youtube: Icon.YoutubeOutlined,
}

const Social = ({ data }) => (
  <Wrapper>
    {data && data.map(item => {
      const Icon = Icons[item.icon]
      return (
        <Button key={item._id} target='__blank' href={item.url}>
          {Icon && <Icon />}
        </Button>
      )
    })}
  </Wrapper>
);

export default Social;
